export enum VehicleQuestionAnswer {
  /**
   * FIRST STEP
  */
  LEASING_NO = 'LEASING_NO',
  LEASING_YES = 'LEASING_YES',
  LEFT_HAND_DRIVE_NO = 'LEFT_HAND_DRIVE_NO',
  LEFT_HAND_DRIVE_YES = 'LEFT_HAND_DRIVE_YES',
  GAS_INSTALLATION_NO = 'GAS_INSTALLATION_NO',
  GAS_INSTALLATION_YES = 'GAS_INSTALLATION_YES',
  VALID_CAR_INSPECTION_NO = 'VALID_CAR_INSPECTION_NO',
  VALID_CAR_INSPECTION_YES = 'VALID_CAR_INSPECTION_YES',

  /**
   * THIRD STEP
  */
  IMMOBILIZER_NO = 'IMMOBILIZER_NO',
  IMMOBILIZER_YES = 'IMMOBILIZER_YES',
  MECHANIC_LOCK_TRANSMISSION_NO = 'MECHANIC_LOCK_TRANSMISSION_NO',
  MECHANIC_LOCK_TRANSMISSION_YES = 'MECHANIC_LOCK_TRANSMISSION_YES',
  AUTOALARM_NO = 'AUTOALARM_NO',
  AUTOALARM_YES = 'AUTOALARM_YES',
  GPS_NO = 'GPS_NO',
  GPS_YES = 'GPS_YES',
  USA_CANADA_REGISTRATION_YES = 'USA_CANADA_REGISTRATION_YES',
  USA_CANADA_REGISTRATION_NO = 'USA_CANADA_REGISTRATION_NO',
  OTHER_SECURITIES_YES = 'OTHER_SECURITIES_YES',
  OTHER_SECURITIES_NO = 'OTHER_SECURITIES_NO',
}
